import { render } from "./CompanyProfile.vue?vue&type=template&id=2512c438&scoped=true"
import script from "./CompanyProfile.vue?vue&type=script&lang=js"
export * from "./CompanyProfile.vue?vue&type=script&lang=js"

import "./CompanyProfile.vue?vue&type=style&index=0&id=2512c438&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2512c438"]])

export default __exports__